module.exports = __webpack_public_path__ + "img/kommune-230.4839650d.svg";